/** Route paths are host-relative; each app uses its own domain in production. */
export const APP_TITLE = 'Genius Dashboard';
export const APP_ROOT_PATH = '/';
export const LOGIN_PATH = '/login';

export const SCHOOL_REPORT_PATH = '/school-report/:schoolId';

export function buildSchoolReportHref(schoolId: string): string {
  const base = import.meta.env.GENIUS_SCHOOL_REPORTS_URL?.trim();
  if (!base) {
    throw new Error(
      '[config] Missing required environment variable "GENIUS_SCHOOL_REPORTS_URL". ' +
        'Set it in the appropriate .env.<mode> file.'
    );
  }
  return `${base}/${encodeURIComponent(schoolId.trim())}`;
}
